<div class="position-relative p-4">
  <i class="position-absolute close bi bi-x-lg" [mat-dialog-close]=""></i>
  <h1>Retirar Dinero</h1>
  <form [formGroup]="cashOutForm" #f="ngForm" (ngSubmit)="withdrawMoney()" *ngIf="listCbu?.length > 0; else withoutCbu">

    <div class="form-control mb-3">
      <select formControlName="currency" (change)="setCurrency()">
        <option value="" default disabled>Elegir moneda</option>
        <option value="ARS">ARS</option>
        <option value="USD">USD</option>
      </select>
    </div>
    <ng-container *ngIf="cashOutForm.get('currency')?.value">
      <ng-container *ngIf="listFilterCbu.length > 0; else withoutAccount">
        <div class="form-control mb-3">
          <select formControlName="cbu">
            <option value="" default disabled>Elegir Cuenta</option>
            <option [value]="l.id" *ngFor="let l of listFilterCbu">
              {{ l.name }}
            </option>
          </select>
        </div>
        <div class="form-control currency mb-3 position-relative">
          <input formControlName="money" type="number" placeholder="Cantidad de Dinero" />
        </div>
        <div class="commision mb-3" *ngIf="cashOutForm.get('money')?.value && fxAndFeed.fees.withdraw">
          <div class="d-flex justify-content-between">
            Comision ({{ fxAndFeed.fees.withdraw * 100}}%) <span><app-money [price]="getCommision()"
                [currency]="cashOutForm.get('currency')?.value"></app-money></span>
          </div>
          <div class="d-flex align-items-center justify-content-between fw-bold border-top pt-2 mt-2">
            Total a Recibir
            <app-money [price]="getTotal()" [currency]="cashOutForm.get('currency')?.value"></app-money>
          </div>
        </div>

        <div class="error text-center my-3" *ngIf="error">{{ error }}</div>
        <button class="primary w-100" type="submit"
          [disabled]="!f.form.valid && cashOutForm.get('currency')?.value == 'USD' ? this.balance.usdAvailable <= cashOutForm.get('money')?.value :  this.balance.arsAvailable <= cashOutForm.get('money')?.value  ">
          Retirar
        </button>
      </ng-container>
      <ng-template #withoutAccount>
        <div class="text-center">
          <button class="primary" (click)="createAccount()" [mat-dialog-close]="">Agregar cuenta</button>
        </div>
      </ng-template>
    </ng-container>
  </form>
  <ng-template #withoutCbu>
    <div class="text-center mt-5">
      <p>No tienes cuentas asociadas en pesos/dólares</p>
      <button class="primary" (click)="createAccount()" [mat-dialog-close]="">Agregar cuenta</button>
    </div>
  </ng-template>
</div>